import { SafeHydrate } from "@/SafeHydrate";
import { Calendar, CircleQuestionMark } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function AppelALActionFinal() {
  return <section data-section-id="252447" id="צרו-קשר" className="bg-primary py-20 md:py-32">
      <div className="page-container">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-primary-foreground sm:text-4xl md:text-5xl mb-6">
            זקוקים למטפל סיעודי מקצועי באופן מיידי?
          </h2>
          
          <p className="font-default text-lg text-primary-foreground/80 md:text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
            אל תשארו לבד ברגעים המאתגרים. אנחנו כאן כדי לספק לכם מענה אנושי, מקצועי ומהיר תוך 5 שעות בלבד, עם התאמה אישית לצרכים של יקירכם.
          </p>
          
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="/ContactPage">
              <Button size="lg" className="h-14 px-8 text-base font-bold shadow-lg bg-secondary text-secondary-foreground hover:opacity-90">
                <SafeHydrate><Calendar className="mr-2 size-5" /></SafeHydrate>
                תיאום ייעוץ ראשוני חינם
              </Button>
            </Link>
            
            <Link to="/ProfessionalBlogPage">
              <Button variant="outline" size="lg" className="h-14 px-8 text-base font-bold border-primary-foreground/20 bg-transparent text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground">
                <CircleQuestionMark className="mr-2 size-5" />
                איך בוחרים מטפל מתאים?
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}